import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from 'src/shared/material/material.module';
import { RpfsaComponent } from './rpfsa.component';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';
import { AppRoutingModule } from './rpfsa.routes';
import { QuotesModule } from './quotes/quotes.module';
import { environment } from '../environments/environment';
import { SharedModule } from './shared/shared.module';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { AppToolbarComponent } from './shared/header/app-toolbar/app-toolbar.component';
import { LandingPageComponent } from './shared/landing-page/landing-page.component';
import { UserInfoComponent } from './shared/user-info/user-info.component';
import { NxModule } from '@nrwl/angular';
import { AppStateModule } from './shared/+state';
import { MAT_AUTOCOMPLETE_DEFAULT_OPTIONS } from '@angular/material/autocomplete';
import { throwIfAlreadyLoaded } from 'src/shared/guards/module-import-guard';
import { AuthModule } from './shared/auth/auth.module';
import { baseUrlProvider, errorHandlerProvider } from 'src/shared/providers';
import { RailProsIconsModule } from './shared/railpros-icons.module';
import { MAT_PAGINATOR_DEFAULT_OPTIONS } from '@angular/material/paginator';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { MsalAuthModule } from './shared/auth/msal-auth.module';

@NgModule({
	declarations: [
		RpfsaComponent,
		PageNotFoundComponent,
		LandingPageComponent,
		UserInfoComponent,
		AppToolbarComponent,
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		MaterialModule,
		HttpClientModule,
		FlexLayoutModule,
		AppRoutingModule,
		ReactiveFormsModule,
		FormsModule,
		AppStateModule,
		SharedModule,
		QuotesModule,
		RailProsIconsModule,
		NxModule.forRoot(),
		LeafletModule,
		AuthModule.forRoot(environment.activeDirectoryOptions),
		MsalAuthModule
	],
	providers: [
		baseUrlProvider,
		errorHandlerProvider,
		{
			provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,
			useValue: { autoActiveFirstOption: true },
		},
		{
			provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
			useValue: {
				pageSizeOptions: [10, 15, 25],
				showFirstLastButtons: true,
			},
		},
		{
			provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
			useValue: {
				duration: 3000,
			},
		},
	],
	bootstrap: [
		RpfsaComponent,
		MsalRedirectComponent
	],
})
export class RpfsaModule {
	constructor(@Optional() @SkipSelf() appStateModule: AppStateModule) {
		throwIfAlreadyLoaded(appStateModule, 'CoreModule');
	}
}
